import { render, staticRenderFns } from "./SHTableSessionCard.vue?vue&type=template&id=2cfc1cb1&"
import script from "./SHTableSessionCard.vue?vue&type=script&lang=ts&"
export * from "./SHTableSessionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports